export enum BrandColor {
  ACCENT = '#f15e22',
  TEXT = '#222723',
  WARNING = '#f3ad2e',
  PRIMARY = '#34668b',
  SECONDARY = '#89bcd9',
  DISABLED = '#939598',
  DANGER = '#a51818'
}
